import { useNavigate } from "@tanstack/react-router"
import { Button } from "design-system/atoms/Button"
import { Plus } from "lucide-react"
import { useCreateCampaignMutation } from "modules/campaigns/hooks/useCreateCampaignMutation"
import { useTranslation } from "react-i18next"

export const CreateCampaignButton = () => {
  const { t } = useTranslation()
  const { mutateAsync: createCampaign, isPending } = useCreateCampaignMutation()
  const navigate = useNavigate()

  async function handleCreateCampaign() {
    const campaign = await createCampaign()

    navigate({ to: "/campaigns/$id/configuration", params: { id: campaign.id } })
  }

  return (
    <Button
      variant="default"
      className="h-full"
      disabled={isPending}
      onClick={handleCreateCampaign}
    >
      <Plus className="size-4" strokeWidth={2} />
      <span>{t("campaigns.builder.title")}</span>
    </Button>
  )
}
